import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBuildings: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBuildings"><Path fillRule="evenodd" clipRule="evenodd" d="M23 20V18H21V7H16V18H15V3H3V18H1V20H23ZM11 8H7V10H11V8ZM11 12H7V14H11V12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBuildings;
